<template>
  <div
    v-if="orderSizeUsd < warningThreshold"
    class="rounded-lg border px-3 py-2.5"
    :class="containerClass"
  >
    <!-- Header -->
    <div class="flex items-center justify-between mb-2">
      <span
        class="text-xs font-semibold"
        :class="labelClass"
      >
        {{ orderSizeUsd < minimumUsd ? 'Below minimum' : 'Near minimum' }}
      </span>
      <span
        class="text-sm font-mono font-bold"
        :class="labelClass"
      >
        ${{ orderSizeUsd.toFixed(2) }}
        <span class="text-xs font-normal opacity-60">/ ${{ minimumUsd }} min</span>
      </span>
    </div>

    <!-- Progress bar -->
    <div class="w-full h-2 rounded-full bg-base-300 overflow-hidden">
      <div
        class="h-full rounded-full transition-all duration-300"
        :class="barColorClass"
        :style="{ width: fillPercent + '%' }"
      />
    </div>

    <!-- Suggestion -->
    <p class="text-xs mt-1.5 opacity-70">
      {{ suggestion }}
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  orderSizeUsd: {
    type: Number,
    required: true,
  },
  minimumUsd: {
    type: Number,
    default: 5,
  },
  warningThreshold: {
    type: Number,
    default: 7,
  },
})

const fillPercent = computed(() => {
  return Math.min(100, Math.max(0, (props.orderSizeUsd / props.warningThreshold) * 100))
})

const isBelowMin = computed(() => props.orderSizeUsd < props.minimumUsd)

const containerClass = computed(() => {
  return isBelowMin.value
    ? 'border-error/30 bg-error/5'
    : 'border-warning/30 bg-warning/5'
})

const labelClass = computed(() => {
  return isBelowMin.value ? 'text-error' : 'text-warning'
})

const barColorClass = computed(() => {
  return isBelowMin.value ? 'bg-error' : 'bg-warning'
})

const suggestion = computed(() => {
  if (isBelowMin.value) {
    return `Bybit requires minimum $${props.minimumUsd} per order. Reduce levels or increase capital.`
  }
  return `Close to the $${props.minimumUsd} minimum. Consider increasing capital or reducing levels.`
})
</script>
